import { DateInputLocalized } from '@components'

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../../../hooks'
import { InvoicingSettingsSection } from '../../../../../../../../enums/invoicingSettingsSection'
import { useTrackAutomaticPaymentReminders } from '../../../../../../hooks/useTrackAutomaticPaymentReminders'
import type { PaymentsAndRemindersSettingsFormSchema } from '../../../../types/paymentsAndRemindersSettingsFormSchema'

export const AutomaticPaymentRemindersStartDate = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<PaymentsAndRemindersSettingsFormSchema>()
  const { trackAutomaticPaymentReminders } = useTrackAutomaticPaymentReminders({
    section: InvoicingSettingsSection.PaymentsAndReminders,
  })

  return (
    <FormItem
      label={t('invoicing_settings.payments_and_reminders.reminders_start_date')}
      name="automaticPaymentRemindersSettings.activationDate"
      render={({ field: { onChange, ref, ...field } }) => {
        const handleDateChange = (date?: Date | null) => {
          trackAutomaticPaymentReminders('Send reminders for invoices issued on or after clicked')
          onChange(date)
        }

        return <DateInputLocalized {...field} onChange={handleDateChange} />
      }}
    />
  )
}
